import { render, staticRenderFns } from "./ShippingInsurancesPopup.vue?vue&type=template&id=37f10598&scoped=true"
import script from "./ShippingInsurancesPopup.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesPopup.vue?vue&type=script&lang=js"
import style0 from "./ShippingInsurancesPopup.vue?vue&type=style&index=0&id=37f10598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f10598",
  null
  
)

export default component.exports